import slugify from "slugify";
import { StaticImageData } from "next/image";

import chef_d_equipe_creation from "../../../assets/images/jobs/chef-equipe-creation.jpg";
import chef_d_equipe_entretien from "../../../assets/images/jobs/chef-equipe-entretien.jpg";
import responsable_de_secteur_entretien from "../../../assets/images/jobs/responsable-secteur-entretien.jpg";
import responsable_de_secteur_creation from "../../../assets/images/jobs/responsable-secteur-creation.jpg";
import bureau_d_etude from "../../../assets/images/jobs/bureau-etude-assistant-commercial.jpg";
import assitance_direction from "../../../assets/images/jobs/assistant-de-direction.jpg";

export interface Job {
  slug: string;
  title: string;
  image: StaticImageData;
  text: string;
  details: { title: string; text: string }[];
}

export const jobsData: Job[] = [
  {
    title: "Chef d’équipe création ",
    image: chef_d_equipe_creation,
    text: /* html */ `<p>Premier responsable du chantier, il a pour mission de rendre un travail soigné, dans les temps tout en respectant les souhaits définis par le client en amont.</p>`,
    details: [
      {
        title: "Compétences requises",
        text: /* html */ `<li>Maitrise de la maçonnerie paysagère</li>
        <li>Connaissance des végétaux (suivant la typologie du chantier)</li>
        <li>Conseiller le client Savoir être un manageur pour son binôme</li>
        <li>Conduite d’engins de chantier type minipelle, chargeuse compacte... </li>`,
      },
      {
        title: "Missions principales",
        text: /* html */ `
        <li>Organise, gère et réalise son chantier</li>
        <li>Prépare ses matériaux et assure l’ approvisionnement des matières premières</li>
        <li>Fait son rapport quotidien au manager de production pour suivre l’ évolution de ses tâches</li>`,
      },
    ],
  },
  {
    title: "Chef d’équipe entretien",
    image: chef_d_equipe_entretien,
    text: /* html */ `<p>Au cœur de l'entretien paysager, engagez-vous dans la réalisation de projets haut de gamme, en assurant une gestion minutieuse des chantiers et en veillant constamment à la satisfaction de nos clients.</p>`,
    details: [
      {
        title: "Compétences requises",
        text: /* html */ `
        <li>Connaissance des végétaux et du jardin en général</li>
        <li>Savoir utiliser les outils tels que tondeuse, taille haie, perche, débroussailleuse, etc...</li>
        <li>Savoir être un manageur pour son binôme</li>
        <li>Connaissance des principales maladies et adventices</li>
        `,
      },
      {
        title: "Missions principales",
        text: /* html */ `<li>Organise, gére et réalise son chantier</li>
        <li>Conseille le client</li>
        <li>Fait son rapport quotidien au responsable de secteur pour suivre l’ évolution de ses tâches</li>`,
      },
    ],
  },
  {
    title: "Responsable de secteur entretien",
    image: responsable_de_secteur_entretien,
    text: /* html */ `<p>Responsable des ventes et de l’ organisation du planning, il veille au bon déroulement des chantiers et à la satisfaction client. </p>`,
    details: [
      {
        title: "Compétences requises ",
        text: /* html */ `<li>Connaissance du végétal et des soins au jardin en général</li>
        <li> Savoir faire les travaux d’ entretien courant</li>
        <li>Maitrise de l’informatique</li>
        <li>Concevoir les plannings d’ intervention</li>
        <li>Savoir manager et animer les équipes</li>`,
      },
      {
        title: "Missions principales",
        text: /* html */ `<li>Manage et planifie l’intervention des équipes</li>
        <li>Vend et conseille les clients</li>
        <li>Suit la bonne réalisation des travaux effectués</li>
        <li>Agit activement à la bonne image de marque de l’entreprise</li>`,
      },
    ],
  },
  {
    title: "Responsable de secteur création",
    image: responsable_de_secteur_creation,
    text: /* html */ `<p>Tout comme dans le secteur de l’entretien, le manager de production est là pour veiller au bon déroulement des travaux. </p>`,
    details: [
      {
        title: "Compétences requises",
        text: /* html */ `
        <li>Connaissance des techniques de pose</li>
        <li>Maitrise de l’informatique</li>
        <li>Concevoir les plannings d’ intervention</li>
        <li>Savoir manager et animer les équipes</li>
        `,
      },
      {
        title: "Missions principales",
        text: /* html */ `
          <li>Manage et planifie l’intervention des équipes</li>
          <li>Conseille les clients</li>
          <li>Suit la bonne réalisation des travaux effectués</li>
          <li>Implante les chantiers en accord avec le client et le bureau d’étude</li>
          <li> Agit activement à la bonne image de marque de l’entreprise</li>
        `,
      },
    ],
  },
  {
    title: "Bureau d’ étude - Assistante commerciale",
    image: bureau_d_etude,
    text: /* html */ `<p>De la découverte client à la réalisation du dossier d’exécution en passant par la conception du projet, ce poste est très transversal. </p>`,
    details: [
      {
        title: "Compétences requises",
        text: /* html */ `
          <li>Bonne connaissance du végétal & du minéral</li>
          <li>Maitrise des outils informatiques et graphiques</li>
          <li>Aisance à l’oral</li>
        `,
      },
      {
        title: "Missions principales",
        text: /* html */ `
          <li>Prend contact avec les clients pour affiner leur demande</li>
          <li>Réalise les études et chiffrages</li>
          <li>Monte le dossier d’ exécution pour les équipes terrains</li>
        `,
      },
    ],
  },
  {
    title: "Assistante de direction",
    image: assitance_direction,
    text: /* html */ `<p>Personne multi-tâche par excellence. Véritable huile dans les rouages, indispensable au quotidien, ses missions sont très variées. Comptabilité, relation client, administratif diverse et varié, accueil client... </p>`,
    details: [
      {
        title: "Compétences requises",
        text: /* html */ `
        <li>Connaissances administratives et règlementaires</li>
        <li>Maitrise des logiciels de paie et de la suite office</li>
        <li>Adaptabilité quotidienne aux sollicitations extérieures</li>
        `,
      },
      {
        title: "Missions principales",
        text: /* html */ `
        <li>Comptabilité</li>
        <li>RH</li>
        <li>Relation client </li>
        <li>Administratif</li>
        `,
      },
    ],
  },
].map((item) => ({
  ...item,
  slug: slugify(item.title, { lower: true, strict: true, trim: true }),
}));
